var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_1674)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6662 10.6159L25 20.0627L37.6385 29.4363C36.6785 31.227 35.4538 32.8546 34.0166 34.2668L20 23.8127L6.00868 34.2916C4.57117 32.884 3.34513 31.2614 2.38267 29.4757L14.9375 20.1252L2.28735 10.7037C3.22915 8.91302 4.43455 7.28257 5.85195 5.86398L19.9375 16.3127L34.0699 5.78613C35.4978 7.19969 36.7139 8.8269 37.6662 10.6159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7999 6.54785C35.2593 7.05295 35.6931 7.58166 36.0994 8.13194L24.437 16.9373L24.562 14.1873L34.7999 6.54785ZM2.82715 9.74155C3.19511 9.12689 3.59515 8.53364 4.02493 7.9641L14.937 15.9998H11.187L2.82715 9.74155ZM35.9701 32.0409C36.3754 31.504 36.7544 30.9461 37.1049 30.369L26.4995 22.5623H23.062L35.9701 32.0409ZM5.29667 33.5582L15.3745 25.9998L14.9995 23.8123L4.00662 32.0112C4.41083 32.5485 4.84149 33.0648 5.29667 33.5582Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.3699 25C39.7812 23.4019 40 21.7265 40 20C40 18.2735 39.7812 16.5981 39.3699 15H25.0625V0.646282C23.4456 0.22451 21.749 0 20 0C18.296 0 16.6418 0.213102 15.0625 0.614109V15H0.630087C0.218765 16.5981 0 18.2735 0 20C0 21.7265 0.218765 23.4019 0.630087 25H15.0625V39.3859C16.6418 39.7869 18.296 40 20 40C21.749 40 23.4456 39.7755 25.0625 39.3537V25H39.3699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.767 23.0625C39.9204 22.0641 40 21.0413 40 20C40 19.0021 39.9269 18.0212 39.7858 17.0625H23.2178L23.3315 0.276214C22.248 0.0945538 21.1351 0 20 0C19.0954 0 18.2049 0.0600523 17.3321 0.176388L17.2178 17.0625H0.2142C0.0730871 18.0212 0 19.0021 0 20C0 21.0413 0.0795847 22.0641 0.233004 23.0625H17.1772L17.0639 39.786C18.0222 39.927 19.0026 40 20 40C21.0419 40 22.0652 39.9203 23.0641 39.7668L23.1772 23.0625H39.767Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_1674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/GBP.f659387442bf171ed99dea3e35bee58b.svg";
export { ForwardRef as ReactComponent };